import useTestId from '@ori/testid-generator';
import { CurrentPrice, OldPrice, PricesHolder, PricesSectionWrapper, PriceStartingFrom } from "./styles";
import { isOldPriceVisible } from "./utils";
import { useProduct } from "../../hooks/internal";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PricesSection = function PricesSection() {
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var _useProduct = useProduct(),
    code = _useProduct.code,
    _useProduct$price = _useProduct.price,
    currentFormatted = _useProduct$price.currentFormatted,
    old = _useProduct$price.old,
    startingFrom = _useProduct$price.startingFrom;
  var oldPriceVisible = isOldPriceVisible({
    currentFormatted: currentFormatted,
    old: old
  });
  return /*#__PURE__*/_jsxs(PricesSectionWrapper, {
    "data-testid": "".concat(getTestId('prices'), "-").concat(code),
    children: [startingFrom ? /*#__PURE__*/_jsx(PriceStartingFrom, {
      children: startingFrom
    }) : null, /*#__PURE__*/_jsxs(PricesHolder, {
      children: [/*#__PURE__*/_jsx(CurrentPrice, {
        oldPriceVisible: oldPriceVisible,
        children: currentFormatted
      }), oldPriceVisible ? /*#__PURE__*/_jsx(OldPrice, {
        children: old
      }) : null]
    })]
  });
};
//# sourceMappingURL=PricesSection.js.map